export default "__VITE_ASSET__jEehT2G0__"